import { render, staticRenderFns } from "./newsfeeds.vue?vue&type=template&id=61ed240d&scoped=true"
import script from "./newsfeeds.vue?vue&type=script&lang=js"
export * from "./newsfeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ed240d",
  null
  
)

export default component.exports